export default {"src":"/_next/static/media/multi-channel-reach.7e7cab92.svg","height":41,"width":41,"blurWidth":0,"blurHeight":0};